import { UserRole } from 'types/user.types';

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_DATA: 'user_data',
  THEME: 'theme',
  LANGUAGE: 'language',
};

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
};

export const PUSH_TYPE_LABELS = {
  regular: 'Regular',
  event: 'Event',
  special: 'Special',
};

export const PUSH_STATUS_LABELS = {
  scheduled: 'Scheduled',
  sending: 'Sending',
  sent: 'Sent',
  failed: 'Failed',
};

export const PUSH_STATUS_COLORS = {
  scheduled: 'default',
  sending: 'processing',
  sent: 'success',
  failed: 'error',
};

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.ADMIN]: 'Administrator',
  [UserRole.EXECUTOR]: 'Executor',
  [UserRole.VIEWER]: 'Viewer',
  [UserRole.ACC_MANAGER]: 'Account Manager',
};

export const USER_ROLE_COLORS: Record<UserRole, string> = {
  [UserRole.ADMIN]: 'red',
  [UserRole.EXECUTOR]: 'blue',
  [UserRole.VIEWER]: 'green',
  [UserRole.ACC_MANAGER]: 'purple',
};

export const APP_TYPE_LABELS = {
  'Android/IOS': 'Mobile (Android/iOS)',
  'PWA': 'Progressive Web App',
};

export const SEGMENT_OPERATORS = {
  equals: '=',
  not_equals: '≠',
  greater_than: '>',
  less_than: '<',
  in: 'IN',
};

export const SEGMENT_FIELD_LABELS = {
  has_registration: 'Has Registration',
  has_deposit: 'Has Deposit',
  locale: 'Locale',
  os: 'Operating System',
  offer: 'Offer',
  install_date: 'Install Date',
};

export const TIME_PERIODS = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'week', label: 'Last 7 days' },
  { value: 'month', label: 'Last 30 days' },
  { value: 'quarter', label: 'Last 90 days' },
  { value: 'custom', label: 'Custom period' },
];

export const CHART_COLORS = {
  primary: '#1890ff',
  success: '#52c41a',
  warning: '#faad14',
  error: '#f5222d',
  purple: '#722ed1',
  cyan: '#13c2c2',
  magenta: '#eb2f96',
  volcano: '#fa541c',
  gold: '#faad14',
  lime: '#a0d911',
};

export const DEFAULT_PAGINATION = {
  current: 1,
  pageSize: 20,
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ['10', '20', '50', '100'],
  showTotal: (total: number, range: [number, number]) => 
    `${range[0]}-${range[1]} of ${total} items`,
};

export const VALIDATION_MESSAGES = {
  required: 'Это поле обязательно для заполнения',
  email: 'Пожалуйста, введите корректный email',
  password: 'Пароль должен содержать минимум 8 символов',
  passwordMatch: 'Пароли не совпадают',
  minLength: (min: number) => `Минимум ${min} символов`,
  maxLength: (max: number) => `Не более ${max} символов`,
  number: 'Значение должно быть числом',
  positiveNumber: 'Значение должно быть положительным числом',
  url: 'Пожалуйста, введите корректный URL-адрес',
  json: 'Пожалуйста, введите валидный JSON',
  bundleId: 'Bundle ID должен быть в формате: com.company.app',
};

export const FILE_UPLOAD_CONFIG = {
  maxSize: 5 * 1024 * 1024,
  accept: {
    images: '.png,.jpg,.jpeg,.gif,.svg',
    documents: '.pdf,.doc,.docx,.xls,.xlsx',
    json: '.json',
  },
};